<div class="main-nav-fixed-container main-nav-header">
  <a [routerLink]="items.businessPageRootLink">
    <img
      class="logo"
      title="SmartHead"
      alt="SmartHead"
      [src]="logoUrl$ | async" />
  </a>
  <div
    class="search"
    *ngIf="searchVisible$ | async"
    (click)="triggerSearch()">
    <sh-search-input (closeSearch)="onCloseSearch()"></sh-search-input>
  </div>
  <a
    class="menu-trigger"
    (click)="open()"
    ><ui-icon key="menu"></ui-icon
  ></a>
</div>

<div
  class="main-nav-mobile-extended"
  *ngIf="(mobile.open$ | async) === true">
  <div class="main-nav-header">
    <a
      [routerLink]="items.businessPageRootLink"
      (click)="onCloseMenu()">
      <img
        class="logo"
        title="SmartHead"
        alt="SmartHead"
        [src]="logoMenuUrl$ | async" />
    </a>
    <a
      class="menu-trigger"
      (click)="onClose()"
      ><ui-icon key="close"></ui-icon
    ></a>
  </div>

  <!-- business items -->
  <div class="main-nav-content">
    <ng-container *ngIf="(nav.isPlatform$ | async) === true; else business">
      <ng-container *ngIf="nav.loggedUser$ | async; else platformNoUser">
        <sh-main-nav-platform-items-for-user-mobile (closeMenu)="onCloseMenu()"></sh-main-nav-platform-items-for-user-mobile>
      </ng-container>
      <ng-template #platformNoUser>
        <sh-main-nav-platform-items-mobile (closeMenu)="onCloseMenu()"></sh-main-nav-platform-items-mobile>
      </ng-template>
    </ng-container>
    <ng-template #business>
      <sh-main-nav-business-items-mobile (closeMenu)="onCloseMenu()"></sh-main-nav-business-items-mobile>
    </ng-template>
  </div>

  <div class="main-nav-footer">
    <div class="divider"></div>

    <ng-container *ngIf="loggedUser$ | async as user; else noUserFooter">
      <sh-main-nav-mobile-footer-for-user (closeMenu)="onCloseMenu()"></sh-main-nav-mobile-footer-for-user>
    </ng-container>
    <ng-template #noUserFooter>
      <sh-main-nav-mobile-footer (closeMenu)="onCloseMenu()"></sh-main-nav-mobile-footer>
    </ng-template>
  </div>
</div>

<div
  class="main-nav-mobile-extended in-search"
  *ngIf="(mobile.inSearch$ | async) === true">
  <div class="search-bar">
    <div class="search">
      <sh-search-input
        #searchInput
        (closeSearch)="onCloseSearch()"></sh-search-input>
    </div>
    <a
      class="menu-trigger"
      [ngClass]="{ '-platform': nav.isPlatform$ | async }"
      (click)="onCloseSearch()"
      ><ui-icon key="close"></ui-icon
    ></a>
  </div>
</div>
